import request from '@/utils/request'

// 查询开单期限申请主单信息
export function getHeadData(applyCode) {
  return request({
    url: `/api/coop/coopDeliveryDueManage/getHeadData/${applyCode}`,
    method: 'get'
  })
}

// 查询物料明细
export function materialDetailQuery(query) {
  return request({
    url: '/api/coop/coopDeliveryDueManageMaterial/pageQuery',
    method: 'get',
    params: query
  })
}

// 查询品类明细
export function catgDetailQuery(query) {
  return request({
    url: '/api/coop/coopDeliveryDueManageCatg/pageQuery',
    method: 'get',
    params: query
  })
}
